/**
 * 拖拽类
 * author LaiWeifeng
 * since 2016/3/22
 */
var Drag = function (target, options) {
  var _x = 0,
    _y = 0,
    _moveDrag,
    _stopDrag
  ;(function () {
    this.target = target //被拖拽的对象
    var defaultOptions = {
      handle: target, //拖拽区域对象
      limit: true, //锁定范围(使不出浏览器范围)
      lock: false, //锁定位置(禁止拖拽)
      lockX: false, //锁定水平位置
      lockY: false, //锁定垂直位置
      container: document.body, //指定限制容器
      onStart: function () {}, //开始时回调函数
      onMove: function () {}, //拖拽时回调函数
      onStop: function () {}, //停止时回调函数
    }
    for (var p in options) defaultOptions[p] = options[p]
    for (var p in defaultOptions) this[p] = defaultOptions[p]

    _moveDrag = bind(this, moveDrag)
    _stopDrag = bind(this, stopDrag)

    this.handle.style.cursor = 'move'
    target.style.top = target.offsetTop + 'px'
    target.style.left = target.offsetLeft + 'px'
    target.style.position = 'absolute' //fixed
    target.style.margin = '0'
    this.container.appendChild(target)
    addHandler(this.handle, 'mousedown', bind(this, startDrag))
  }).apply(this, arguments)

  this.toCenter = function () {
    var w = document.querySelector('#video-container').offsetWidth

    var h = document.querySelector('#video-container').offsetHeight
    var tw = 500
    var th = 250
    var top = (h - 100 - th) / 2
    top = Math.max(0, top)
    this.target.style.left = (w - tw) / 2 + 'px'
    this.target.style.top = top + 'px'
  }

  function startDrag(event) {
    var event = event || window.event
    _x = event.clientX - target.offsetLeft
    _y = event.clientY - target.offsetTop
    addHandler(this.container, 'mousemove', _moveDrag)
    addHandler(this.container, 'mouseup', _stopDrag)
    addHandler(this.container, 'mouseleave', _stopDrag)
    event.preventDefault && event.preventDefault()
    this.handle.setCapture && this.handle.setCapture()
    this.onStart && this.onStart()
  }

  function moveDrag(event) {
    var event = event || window.event
    if (this.lock) return
    var iTop = event.clientY - _y
    var iLeft = event.clientX - _x
    var maxTop = this.container.clientHeight - target.offsetHeight
    var maxLeft = this.container.clientWidth - target.offsetWidth
    if (this.limit) {
      iTop = iTop < 0 ? 0 : iTop
      iTop = iTop > maxTop ? maxTop : iTop
      iLeft = iLeft < 0 ? 0 : iLeft
      iLeft = iLeft > maxLeft ? maxLeft : iLeft
    }
    this.lockY || (target.style.top = iTop + 'px')
    this.lockX || (target.style.left = iLeft + 'px')
    event.preventDefault && event.preventDefault()
    this.onMove && this.onMove()
  }

  function stopDrag() {
    removeHandler(this.container, 'mousemove', _moveDrag)
    removeHandler(this.container, 'mouseup', _stopDrag)
    removeHandler(this.container, 'mouseleave', _stopDrag)
    this.handle.releaseCapture && this.handle.releaseCapture()
    this.onStop && this.onStop()
  }

  //添加绑定事件
  function addHandler(oElement, sEventType, fnHandler) {
    return oElement.addEventListener
      ? oElement.addEventListener(sEventType, fnHandler, false)
      : oElement.attachEvent('on' + sEventType, fnHandler)
  }
  //删除绑定事件
  function removeHandler(oElement, sEventType, fnHandler) {
    return oElement.removeEventListener
      ? oElement.removeEventListener(sEventType, fnHandler, false)
      : oElement.detachEvent('on' + sEventType, fnHandler)
  }
  //绑定事件到对象
  function bind(object, fnHandler) {
    return function () {
      return fnHandler.apply(object, arguments)
    }
  }
}

module.exports = Drag
